export default "__VITE_ASSET__CJEDuoif__"